module.exports = __webpack_public_path__ + "static/media/neo4j.e0485df8.png";